import { ResponseObject } from './CommonModel';

export enum AlarmState {
	Active = 0,
	Acknowledged,
	Cleared,
}

export type AlarmNote = {
	Date: Date;
	Text: string;
	OperatorName: string;
	AlarmId: number;
	AlarmNoteId: number;
	Type: number;
};

export type AlarmDetail = {
	ActiveAlarmId: number;
	HostTime: Date;
	HardwareTime: Date;
	Operator: string;
	Workstation: string;
	Time: Date;
	AlarmNotes: AlarmNote[];
	IsChecked: boolean;
	IsExpandableRowHeader: boolean;
};

export type AlarmModel = {
	AlarmDetails: AlarmDetail[];
	EventId: number;
	Description: string;
	Address: string;
	Level: number;
	State: AlarmState;
	Status: number;
	Secures: number;
	ReturnedToNormal: boolean;
	Instructions: string;
	Count: number;
	AlarmSoundInfo: AlarmSoundInfo;
};

export type AlarmSoundInfo = {
	ActiveId: number;
	Path: string;
	Address: string;
	Data: string;
	ContentType: string;
};

export type AlarmListResponseObject = {
	alarmList: AlarmModel[];
	totalRecords: number;
	totalPages: number;
	pageNumber: number;
} & ResponseObject;

export type AlarmAssessmentCode = {
	Id: number;
	Name: string;
	Text: string;
};

export enum AlarmAcknowledgementActions {
	None = 0,
	AcknowledgedOne,
	AcknowledgedMultiple,
	AcknowledgedAll,
	ClearOneUnacknowledged,
	ClearMultipleUnacknowledged,
	ClearAllUnacknowledged,
	ClearOneAcknowledged,
	ClearMultipleAcknowledged,
	ClearAllAcknowledged,
}

export type AlarmSoundConfiguration = {
	MakeDelay: boolean;
	SilenceBeep: boolean;
	SilenceCustom: boolean;
	BackgroundPlay: boolean;
	DelaySeconds: number;
};

export enum AlarmAcknowledgementErrorCode {
	Success = 0,
	ActionDoesNoteMatchAlarmCount,
	AlarmAndNotesCountDoNotMatch,
	RequiresNote,
	SystemError,
}

export type AlarmAcknowledgementResults = {
	AlarmAckErrorCode: AlarmAcknowledgementErrorCode;
} & ResponseObject;

export type AcknowledgedAndClearAlarmsPayload = {
	action: AlarmAcknowledgementActions;
	alarmIds: number[];
	operatorNotes: AlarmNote[];
	alarmsDetails?: AlarmModel[];
	addOperatorNoteCallback: (action: AlarmAcknowledgementActions, payload: AcknowledgedAndClearAlarmsPayload) => void;
	acknowledgeAndClearCallback: (payload: AcknowledgedAndClearAlarmsPayload) => void;
};

export type AlarmNoteForAcknowledge = {
	isAlarmNoteForAcknowledge: boolean;
	acknowledgeAction: AlarmAcknowledgementActions;
	alarms: OperatorNoteAlarm[];
};

export type OperatorNoteAlarm = Pick<AlarmModel, 'EventId' | 'Description' | 'Address' | 'Level' | 'State' | 'Status' | 'Secures' | 'ReturnedToNormal'> &
	Pick<AlarmDetail, 'ActiveAlarmId' | 'HostTime' | 'HardwareTime' | 'Operator' | 'Workstation' | 'Time'>;
